import React, { forwardRef } from 'react';
import get from 'lodash/get';
import Table from '../../../../../../components/Common/Table';
import MultiSeriesLineChart from '../../../MultiSeriesLineChart';
import { View } from '../../../../../../components/Common/react-native-components';
import {
  buildMonthSeriesForMultiLineChart,
  convertCstDataIntoTableCompatibleData,
  currentDateFormat,
  DATE_FORMAT_MAPPING,
  seprateDateAndNonDateColumns
} from '../../../../../../utils/transformChartsAndTableData';
import moment from 'moment';
import { CHART_COLORS } from '../../../../constants';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';
import MultiFeatureCard from '../../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import LowerSampleSizeFooter from '../../../../../../components/Common/LowerSampleSizeFooter';

const ScoreBySource = forwardRef((props, ref) => {
  const { item, timeperiodLabel } = props;
  const itemData = item;
  const lowSampleSize = get(item, 'lowSampleSize');

  if (!get(itemData, 'cstData')) {
    return <GenericNoData />;
  }

  const tableData = convertCstDataIntoTableCompatibleData(get(itemData, 'cstData') || {});

  const notAllowedColumns = ['# of records'];
  const { columns = [], metric_data = [], rows = [] } = get(itemData, 'cstData') || {};

  let multiLineChartData = buildMonthSeriesForMultiLineChart(columns, rows, metric_data, CHART_COLORS);

  let finalData = multiLineChartData?.map((e, index) => {
    const rowData = get(tableData, ['table_rows', index]);
    return {
      ...e,
      label: {
        value: get(rowData, 'total'),
        label: 'Total Pecentage'
      },
      subLabel: {
        value: get(rowData, 'benchmark_sample_size'),
        label: 'Same Period Ago'
      }
    };
  })?.filter(e => !notAllowedColumns.includes(e.name));
  const chartCategories = seprateDateAndNonDateColumns(columns)?.dateFields?.map(e => {
    let dateFormat = currentDateFormat(e);
    return moment(e, dateFormat).format(DATE_FORMAT_MAPPING[dateFormat]);
  });

  const renderContent = (activeSwitch, contentRef) => {
    switch (activeSwitch) {
      case 'BAR':
        return (
          <MultiSeriesLineChart
            ref={contentRef}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'line'}
            data={finalData || []}
          />
        );
      case 'TIME':
        return (
          <MultiSeriesLineChart
            ref={contentRef}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'column'}
            data={finalData || []}
          />
        );
      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={lowSampleSize} table_data={tableData} expendable={false} />
          </View>
        );
      default:
        return null;
    }
  };

  return (
    <MultiFeatureCard
      title={item?.title}
      subTitle={`Time Period: ${timeperiodLabel}`}
      style={{ childContainer: { paddingVertical: 20 } }}
      enableActionBtn={item?.enableActionBtn}
      enableSwitchTab={item?.enableSwitchTab}
      switchOptions={item?.switchOptions}
      renderContent={renderContent}
      renderFooter={() => <LowerSampleSizeFooter size={get(item, 'lowSampleSize')} />}
    />
  );
});

export default ScoreBySource;
